import { render } from "./MainB2B.vue?vue&type=template&id=6eac44d7"
import script from "./MainB2B.vue?vue&type=script&lang=js"
export * from "./MainB2B.vue?vue&type=script&lang=js"

import "./MainB2B.vue?vue&type=style&index=0&id=6eac44d7&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__